import { FC } from 'react';
import { AlertIcon } from 'shared/ui';
import s from './styles.module.scss';

interface ContentSubmitProps {
	title: string;
	count: string;
}
const ContentSubmit: FC<ContentSubmitProps> = ({ title, count }) => {
	return (
		<div className={s.contentSubmit}>
			<div className={s.contentSubmit__icon}>
				<AlertIcon color={'#FA8C16'} />
			</div>
			<div className={s.contentSubmit__title}>{title}</div>
			<div className={s.contentSubmit__count}>{count}</div>
		</div>
	);
};

export default ContentSubmit;
